<template>
  <div>
    <auto-updates-card-skeleton v-if="phpSettingsLoading" />
    <v-card
      v-else
      elevation="4"
    >
      <v-card-text
        class="d-flex justify-space-between text--gray-darken2"
      >
        <div>
          <h6>{{ $t("heading.instance.advanced.developer.phpSettings.title") }}</h6>
          <p class="mb-0 mt-1">{{ $t("heading.instance.advanced.developer.phpSettings.subtitle") }}</p>
          <AlertSm
            v-if="phpSettingsConfigurable"
            :class="'alert-sm--primary mt-3'"
            :text="$t('heading.instance.advanced.developer.phpVersion.alert')"
          />
          <AlertSm
            v-else
            :class="'alert-sm--primary mt-3'"
            :text="$t('heading.instance.advanced.developer.phpSettings.alert')"
          />
        </div>
        <div class="d-flex align-center">
          <v-btn
            elevation="0"
            class="mt-0 pt-0 v-btn--default"
            :disabled="!phpSettingsConfigurable"
            @click="phpSettingsModalOpen = true"
          >
            <span class="font-weight-bold">{{ $t("button.manage") }}</span>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <php-settings-modal
      :open.sync="phpSettingsModalOpen"
      :instance="instance"
      :php-settings="phpSettings"
      :custom="phpSettingsCustom"
      :suggested-directives="suggestedDirectives"
      :modifiable-directives-list="modifiableDirectivesList"
    />
  </div>
</template>

<script>
import AlertSm from "@/components/alerts/AlertSm.vue";
import PhpSettingsModal from "@/views/instance/advanced/DeveloperSettings/PhpSettingsModal.vue";
import Api from "@/apis/Api";
import AutoUpdatesCardSkeleton from "@/components/cards/AutoUpdatesCardSkeleton.vue";

export default {
  name: "PhpSettingsCard",
  components: {AutoUpdatesCardSkeleton, PhpSettingsModal, AlertSm},
  props: {
    instance: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      phpSettingsModalOpen: false,
      phpSettingsLoading: false,
      phpSettings: [],
      phpSettingsConfigurable: false,
      phpSettingsCustom: false,
      suggestedDirectives: [],
      modifiableDirectivesList: true,
    }
  },
  mounted() {
    this.loadPhpSettingsModal();
  },
  methods: {
    enrichDirective(item, suggestedDirectives) {
      const suggested = suggestedDirectives.find(d => d.directive === item.directive);
      if (suggested) {
        item.type = suggested.type === 'select' ? 'select' : 'text';
        item.options = suggested.options || [];
      }
      item.editing = false;
      return item;
    },
    loadPhpSettingsModal() {
      this.phpSettingsLoading = true;
      Api.get(`/server-accounts/${this.instance.hostingId}/domains/${this.instance.domain}/php-settings`)
        .then((response) => {
          const suggestedDirectives = response.data.suggested_directives || [];
          this.suggestedDirectives = suggestedDirectives;
          this.modifiableDirectivesList = response.data.modifiable_directives_list !== false;
          this.phpSettings = response.data.directives.map(item =>
            this.enrichDirective(item, suggestedDirectives)
          );
          this.phpSettingsCustom = response.data.custom_directives;
          this.phpSettingsConfigurable = response.data.configurable;
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.phpSettingsLoading = false;
        });
    },
  }
}
</script>

<style lang="scss" scoped>
.v-card--mobile {
  @media (max-width: 767px) {
    flex-direction: column;
    .v-btn--default {
      margin-top: 16px;
    }
  }
}
</style>